export default __webpack_public_path__ + "0625fb69.jpg";